import Carousel from "../components/ui/Carousel";
import { Icon } from '@iconify/react';
import AnimatedSection from '../components/ui/AnimatedSection';
import PageBanner from '../components/layout/PageBanner';

const especialidades = [
  { icon: 'mdi:factory', titulo: 'Retail', desc: 'Sistemas para tiendas físicas y retail.' },
  { icon: 'mdi:shopping', titulo: 'Ecommerce', desc: 'Tiendas online con IA integrada.' },
  { icon: 'mdi:robot', titulo: 'IA', desc: 'Agentes y automatización inteligente.' },
  { icon: 'mdi:account-group', titulo: 'Equipo', desc: 'Profesionales con experiencia real.' },
];

const servicios = [
  'Automatización de procesos comerciales',
  'Sistemas de gestión empresarial (ERP)',
  'Tiendas online con agentes IA',
  'Chatbots y atención automatizada 24/7',
  'Integración con sistemas legacy',
];

export default function Nosotros(){
    return(
    <main className="bg-[#f5f5f7] text-[#2d2d44]">
            <PageBanner
              titulo="Nosotros"
              crumbs={[
                { label: 'Inicio', href: '/' },
                { label: 'Nosotros' },
              ]}
            />
            <div className="max-w-7xl mx-auto px-4 py-12">
                <AnimatedSection className="text-center max-w-3xl mx-auto mb-12">
                    <p className="text-lg text-gray-600 leading-relaxed">
                    Somos un equipo especializado en <strong className="text-[#f26724]">automatización empresarial, retail, ecommerce e inteligencia artificial aplicada a negocios</strong>. Ayudamos a empresas a reducir trabajo manual, optimizar procesos y aumentar ventas mediante software inteligente.
                    </p>
                </AnimatedSection>

                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 max-w-3xl mx-auto mb-16">
                    {especialidades.map((esp, i) => (
                        <AnimatedSection key={i} animation="fade-in-up" delay={i * 100} className="bg-white border border-black/10 rounded-xl p-5 text-center hover:border-[#f26724]/30 hover:-translate-y-0.5 transition-all shadow-sm">
                            <Icon icon={esp.icon} className="text-3xl text-[#f26724] mb-3 mx-auto" />
                            <h5 className="text-[#f26724] font-semibold mb-1">{esp.titulo}</h5>
                            <p className="text-xs text-gray-500">{esp.desc}</p>
                        </AnimatedSection>
                    ))}
                </div>

                <AnimatedSection className="max-w-3xl mx-auto mb-16">
                    <h4 className="text-xl font-semibold text-[#f26724] mb-4 text-center text-glow">¿Qué hacemos?</h4>
                    <p className="text-gray-600 leading-relaxed mb-6 text-center">
                    Analizamos tus procesos empresariales para automatizar áreas que requieren eficiencia y agilidad. Creamos soluciones que te permiten administrar tu negocio de forma fluida, eliminando complicaciones y demoras.
                    </p>
                    <div className="max-w-lg mx-auto space-y-3">
                        {servicios.map((svc, i) => (
                            <AnimatedSection key={i} animation="fade-in-left" delay={i * 80} className="flex items-center gap-3 text-gray-700">
                                <Icon icon="mdi:check-circle" className="text-[#f26724] text-lg flex-shrink-0" />
                                <span>{svc}</span>
                            </AnimatedSection>
                        ))}
                    </div>
                </AnimatedSection>

                <hr className="border-black/10 mb-12" />
                <AnimatedSection>
                  <h4 className="text-2xl font-semibold text-[#f26724] text-center mb-8">Tecnología con las que trabajamos</h4>
                <Carousel />
                </AnimatedSection>
            </div>
    </main>
    )
}
